<template>
  <section class="top-hero"
    :class="[
      background.load === 'loading' ? 'is-loading' : '',
      background.load === 'loaded' ? 'is-loaded' : '',
    ]">
    <v-scroll-animation>
      <div class="top-hero__bg">
        <img class="top-hero__bg-img--loading" src="/choice/img/top/hero-gogatsu-sm.jpg" alt="">
        <transition name="animation-fade">
          <img v-show="background.load === 'loaded'" :loading="background.load = 'loaded'" class="top-hero__bg-img" src="/choice/img/top/hero-gogatsu.jpg" alt="">
        </transition>
      </div>

      <div class="top-hero__wrap">
        <div class="top-hero__logo">
          <img src="/choice/img/common/choice-logo-vertical.png" alt="">
        </div>
        <div class="top-hero__inner">
          <div class="top-hero__description">
            <p>
              ひととえではお人形やお道具などを自由な感性で楽しみながらシュミレーションできる新サービス、「<strong>WEB de カスタマイズ</strong>」をスタートしました。
            </p>
          </div>
          <router-link class="top-hero__link" :to="config.path.root_gogatsu + '/step/sizes/1'">
            <span class="top-hero__link-inner">はじめる<i class="fas fa-arrow-right"></i></span>
          </router-link>
        </div>
      </div>
    </v-scroll-animation>
  </section>
</template>



<script>
export default {
  components: {
    'v-scroll-animation': require('@/components/scroll-animation.vue').default,
  },
  data() {
    return {
      background: {
        load: 'loading',
      },
    }
  },
}
</script>



<style lang="scss">

.app-gogatsu .top-hero {
    &__bg-img {
        position: absolute;
        top: 50%;
        left: 80%;
        @include breakpoints-min(sm) {
            top: 50%;
            left: 77%;
        }
        @include breakpoints-min(md) {
            top: 50%;
            left: 94%;
        }
        @include breakpoints-min(lg) {
            top: 50%;
            left: 76%;
        }
        @include breakpoints-min(xl) {
            top: 50%;
            left: 50%;
        }
    }
    &__inner {
        @include breakpoints-min(sm) {
            left: 110px;
        }
        @include breakpoints-min(md) {
            top: 64px;
            left: 32px;
        }
        @include breakpoints-min(xl) {
            top: 64px;
            left: 520px;
        }
    
    }
    &__link {
        &::before {
            background: url(/choice/img/top/bg-2-gogatsu.svg) no-repeat;
        }
    }
}

@keyframes top-hero-link {
  0% {
    transform: translate(-50%, -50%) rotate(0);
  }
  100% {
    transform: translate(-50%, -50%) rotate(720deg);
  }
}
</style>
